import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NgClass } from '@angular/common';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { SidebarItemStore } from '@core/components/sidebar/components/sidebar-item/sidebar-item.store';
import { SidebarService } from '@core/components/sidebar/service/sidebar.service';

@Component({
  selector: 'app-sidebar-item-expanded-subpages',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, RouterLink, RouterLinkActive],
  template: `
    @for (subPage of subPages()!; track subPage.path) {
      <a
        class="flex w-full"
        routerLink="/{{ subPage.path }}"
        routerLinkActive
        (isActiveChange)="updateActiveRoute(subPage.path, $event)">
        <span
          class="mr-2 ml-1 w-full cursor-pointer items-center truncate pt-1 pr-1 pb-1.5 pl-2 text-nowrap"
          [ngClass]="subpageLabelClasses(subPage.path)">
          {{ subPage.label }}
        </span>
      </a>
    }
  `,
})
export class SidebarItemExpandedSubpagesComponent {
  /** INJECTIONS **/
  /****/
  private readonly store = inject(SidebarItemStore);

  /****/
  private readonly service = inject(SidebarService);

  /** PROPERTIES **/
  /****/
  protected readonly subPages = this.store.subPages;

  /****/
  protected readonly activeRoute = toSignal(this.service.routeChanged$);

  protected subpageLabelClasses(path: string) {
    const isActive = path === this.activeRoute();

    const activeText = 'font-medium';
    const activeUnderline = 'underline underline-offset-[0.5em]';
    const activeDecoration = 'decoration-2 decoration-greenish-500';

    const notActiveUnderline = 'hover:underline hover:underline-offset-[0.5em]';
    const notActiveDecoration = `hover:decoration-2 hover:decoration-[var(--text-contrast-base-color)]`;

    return {
      [`${activeText} ${activeUnderline} ${activeDecoration}`]: isActive,
      [`${notActiveUnderline} ${notActiveDecoration}`]: !isActive,
    };
  }

  protected updateActiveRoute(route: string, active: boolean) {
    this.service.setActiveRoute(route, active);
  }
}
